import React from 'react';
import { useDispatch } from 'react-redux';
import { AudioSelectionType } from 'redux/modules/edit-automation';

import { replaceModal } from 'redux/modules/modal';
import useEditAutomationModal from '../hooks/useEditAutomationModal';

import { mapAudioSelectionUpdateData } from './utils';

const useEditAudioSelection = (subscriptionId?: number) => {
  const dispatch = useDispatch();
  const { onUpdateAutomation, subscription } = useEditAutomationModal(
    subscriptionId,
  );

  const onGoBackToAudioSelection = React.useCallback(() => {
    dispatch(
      replaceModal({
        name: 'EditAutomationAudioSelectionTypeModal',
        params: {
          subscriptionId,
        },
      }),
    );
  }, [dispatch, subscriptionId]);

  const onConfirmAudioSelection = React.useCallback(
    async (type: AudioSelectionType) => {
      const updateAutomationData = mapAudioSelectionUpdateData({
        selectedAudioKey: type,
        subscription,
      });
      onUpdateAutomation(updateAutomationData, 'audio selection');
    },
    [onUpdateAutomation, subscription],
  );

  return {
    onConfirmAudioSelection,
    onGoBackToAudioSelection,
  };
};

export default useEditAudioSelection;
